export const isCurrentRoute = (currentRoute, component) => {
    if (!currentRoute || !component) return;
    return currentRoute.type.displayName == component.type.displayName
}